<template>
  <section class="grid-flex column">
    
    <div class="box flex-1 w100 margin-to-l">
        <div class="box-title">
          <div>
            <b>Tag de Acompanhamento</b>
          </div>
          <div class="margin-top-s">
            <p>Para o hot Tracker funcionar corretamente, é necessário que a tag seja instala em todas suas páginas (site).</p>
          </div>
        </div>
        <div class="box-content">
          <div class="flex">
            <div class="flex-1 code w100">
              &lt;!-- UnicoTracker --&gt;<br>
              &lt;script&gt;<br>
              (function(l,d,t,r,c,k){<br>
              if(!l.lh){l.lh=l.lh||{_c:[]};<br>
              c=d.getElementsByTagName(&#39;head&#39;)[0];<br>
              k=d.createElement(&#39;script&#39;);k.async=1;<br>
              k.src=t;c.appendChild(k);}<br>
              l.lht = l.lht || function(k,v){l.lh._c.push([k,v])};<br>
              lht(&#39;up&#39;, &#39;{{ accountCode }}&#39;)<br>
              })(window,document,&#39;//tag.lhtrack.com.br/{{accountId}}.js?v=1&#39;);<br>
              &lt;/script&gt;<br>
              &lt;!-- End UnicoTracker --&gt;<br>
            </div>
          </div>
          <div class="flex margin-top-l column">
            <p>Para configurar sua Tag de acompanhamento para a maxima performance recomendados deixar <b>TRACKEAMENTO AVANÇADO</b> e <b>TRACKEAMENTO DE LEADS</b> ATIVADAS.</p>
            <div class="flex flex-1 margin-top-l w100">
              <div class="flex-1">
                <label>Trackeamento Avançado</label>
                <div class="margin-top-s">
                  <m-switch
                    v-if="!loading"
                    v-model="myTag.advance_tracker"
                    @change="updateTag()"
                  ></m-switch>
                  <div v-else class="loading-adjust">
                    <content-loading>
                      <fake-line height="30"></fake-line>
                    </content-loading>
                  </div>

                </div>
              </div>
              <div class="flex-1">
                <label>Trackeamento de Leads</label>
                <div class="margin-top-s">
                  <m-switch
                    v-if="!loading"
                    v-model="myTag.lead_capture"
                    @change="updateTag()"
                  ></m-switch>
                  <div v-else class="loading-adjust">
                    <content-loading>
                      <fake-line height="30"></fake-line>
                    </content-loading>
                  </div>
                </div>
              </div>
              <div class="flex-1">
                <label>Trackeamento de Iframes</label>
                <div class="margin-top-s">
                  <m-switch
                    v-if="!loading"
                    v-model="myTag.have_iframe"
                    @change="updateTag()"
                  ></m-switch>
                  <div v-else class="loading-adjust">
                    <content-loading>
                      <fake-line height="30"></fake-line>
                    </content-loading>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex column margin-top-l">
              <h3>Gerenciador PIXEL / TAG:</h3>
              <p class="margin-top-s">Ative o disparo dos pixels para não precisar adicionar manualmente eles na sua Página. Basta ativar e cadastrar em TAG / PIXELS.</p>
              <div class="flex-1 flex w100 margin-top-s">
                <div class="flex-1 margin-top-s">
                  <label>PIXELS FACEBOOK ADS</label>
                  <div class="margin-top-s">
                    <m-switch
                      v-if="!loading"
                      v-model="myTag.init_facebook_pixel"
                      @change="updateTag()"
                    ></m-switch>
                    <div v-else class="loading-adjust">
                      <content-loading>
                        <fake-line height="30"></fake-line>
                      </content-loading>
                    </div>
                  </div>
                </div>
                
                <div class="flex-1 margin-top-s">
                  <label>TAGS GOOGLE ADS</label>
                  <div class="margin-top-s">
                    <m-switch
                      v-if="!loading"
                      v-model="myTag.init_google_pixel"
                      @change="updateTag()"
                    ></m-switch>
                    <div v-else class="loading-adjust">
                      <content-loading>
                        <fake-line height="30"></fake-line>
                      </content-loading>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="flex-1">
              <h3>Plugin para WordPress:</h3>
              <div class="flex column margin-top-s">
                <div>
                  Caso use um site em WordPress, você pode fazer a instalação da tag de acompanhamento com nosso plugin.
                </div>
                <a :href="urlPlugin">
                  <div class="button secondary margin-top-s">
                    Baixar Plugin
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="flex-1">
              <h3>Testar instalação da Tag:</h3>
              <div class="flex middle margin-top-s">
                <input class="input" type="text" placeholder="https://unicotracker.com.br" v-model="urlTest" />
                <div @click="openTeste()" class="button primary btn-teste">Testar</div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="box flex-1 w100 margin-top-l">
        <div class="box-title">
          <b>Código de TRACKER - FACEBOOK ADS</b>
        </div>
        <div class="box-content">
          Adicione em todos seus anúncios do facebook, o código abaixo nos parametros de URL.
          <div class="flex flex-1">
            <div class="code w100 margin-top-l min-code">
                {{ codeTrack }}
            </div>
            <div class="code w100 margin-top-l min-code">
                <ul>
                  <li v-for="(v, k) in splitCodeTrack" :key="k">{{ v }}</li>
                </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box flex-1 w100 margin-top-l">
        <div class="box-title">
          <b>Código de TRACKER - GOOGLE ADS</b>
        </div>
        <div class="box-content">
          Adicione o código de tracker para google ads no nível de conta. Configurações -> Tracker.
          <div class="code w100 margin-top-l">
              {{ gadscodeTrack }}
          </div>
        </div>
      </div>

      <div class="box flex-1 w100 margin-top-l">
        <div class="box-title">
          <b>Código de TRACKER - REDTRACK</b>
        </div>
        <div class="box-content">
          Adicione o código de tracker para red track.
          <div class="code w100 margin-top-l">
              {{ redtrackcodeTrack }}
          </div>
        </div>
      </div>
  </section>
</template>

<script>


import MSwitch from "@/components/MSwitch.vue";

import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";

import {
  getTagTrack,
  updateTagTrack
} from "@/services/tagTrack";



export default {
  name: "trackingV2",
  components: { 
    MSwitch
  },
  data() {
    return {
      loading: false,
      showModalGuia: false,
      teste: true,
      urlTest: '',
      myTag: {
        advance_tracker: false,
        lead_capture: false,
        have_iframe: false,
        init_facebook_pixel: false,
        init_google_pixel: false,
      },
      codeTrack: "utm_campaign={{campaign.name}}&utm_source={{placement}}&utm_content={{ad.name}}&utm_medium=CGA{{campaign.id}}_{{adset.id}}_{{ad.id}}&lhtrack=LH{{campaign.id}}_{{adset.id}}_{{ad.id}}",
      gadscodeTrack: "utm_campaign={campaignid}&utm_source={adgroupid}&utm_content={creative}&utm_medium=CGA{campaignid}_{adgroupid}_{creative}&lhtrack=LH{campaignid}_{adgroupid}_{creative}",
      redtrackcodeTrack: "utm_campaign={sub6}&utm_source={sub7}&utm_content={sub4}&utm_medium=CGA{sub3}_{sub2}_{sub1}&lhtrack=LH{sub3}_{sub2}_{sub1}",
    };
  },
  mounted() {
    this.getTagTrack()
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    splitCodeTrack() {
      return this.codeTrack.split('&')
    },
    accountCode() {
      if (!this.account) {
        return ''
      }

      return this.encode(this.account.id)
    },
    accountId() {
      if (!this.account) {
        return ''
      }
      return this.account.id
    },
    urlPlugin() {
      return `${window.location.origin}/admin/static/pluginwp/unicotracker-v1.0.1.zip`
    },
  },
  methods: {
    getTagTrack() {
      this.loading = true
      getTagTrack()
        .then((result) => {
          this.myTag = result
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateTag() {
      updateTagTrack(this.myTag)
        .then((result) => {
          this.myTag = result

          this.$toast.success({
            title:'Sucesso',
            message:'Configuração da tag Editada'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    openTeste() {
      if (!this.urlTest) {
        this.$toast.error({
          title:'Erro',
          message:'Precisa preencher a url para testar'
        })
      }

      var url = this.urlTest

      if (!url.includes('http')) {
        url = `http://${url}`
      }

      window.open(`${url}?verify_lh_tag=true`, '_blank').focus()
    },
    encode(acc) {
      const base62 = {
        charset: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""),
        encode: integer => {
          if (integer === 0) {
            return 0;
          }
          let s = [];
          while (integer > 0) {
            s = [base62.charset[integer % 62], ...s];
            integer = Math.floor(integer / 62);
          }
          return s.join("");
        },
        decode: chars =>
          chars
            .split("")
            .reverse()
            .reduce((prev, curr, i) => prev + base62.charset.indexOf(curr) * 62 ** i, 0)
      };

      return base62.encode(acc);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-teste {
  padding: 15px 20px;
  margin-left: 8px;
}

.grid-flex .box + .box, .flex .box + .box {
  margin-left: 0px !important;
}  
.loading-adjust {
  max-width: 140px;
}
.min-code {
  min-height: 180px;
  margin-left: 4px;
}
</style>
